var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuBarcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66658 5.00939C1.66661 4.08893 2.41279 3.34277 3.33325 3.34277H5.83317C6.29341 3.34277 6.6665 3.71587 6.6665 4.17611C6.6665 4.63634 6.29341 5.00944 5.83317 5.00944H3.33325L3.33317 7.50947C3.33316 7.9697 2.96005 8.34279 2.49981 8.34277C2.03957 8.34276 1.66649 7.96965 1.6665 7.50941L1.66658 5.00939ZM13.3332 4.17611C13.3332 3.71587 13.7063 3.34277 14.1665 3.34277H16.6665C17.587 3.34277 18.3332 4.08897 18.3332 5.00944V7.50944C18.3332 7.96968 17.9601 8.34277 17.4998 8.34277C17.0396 8.34277 16.6665 7.96968 16.6665 7.50944V5.00944H14.1665C13.7063 5.00944 13.3332 4.63634 13.3332 4.17611ZM2.49988 11.6761C2.96011 11.6761 3.33321 12.0492 3.33322 12.5094L3.33326 15.0094H5.83317C6.29341 15.0094 6.6665 15.3825 6.6665 15.8428C6.6665 16.303 6.29341 16.6761 5.83317 16.6761H3.33326C2.4128 16.6761 1.66661 15.9299 1.66659 15.0095L1.66655 12.5095C1.66655 12.0492 2.03964 11.6761 2.49988 11.6761ZM17.4998 11.6761C17.9601 11.6761 18.3332 12.0492 18.3332 12.5094V15.0094C18.3332 15.9299 17.587 16.6761 16.6665 16.6761H14.1665C13.7063 16.6761 13.3332 16.303 13.3332 15.8428C13.3332 15.3825 13.7063 15.0094 14.1665 15.0094H16.6665V12.5094C16.6665 12.0492 17.0396 11.6761 17.4998 11.6761Z",
    fill: "#21272F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.74984 5.84277C9.21007 5.84277 9.58317 6.21587 9.58317 6.67611V13.3428C9.58317 13.803 9.21007 14.1761 8.74984 14.1761C8.2896 14.1761 7.9165 13.803 7.9165 13.3428V6.67611C7.9165 6.21587 8.2896 5.84277 8.74984 5.84277Z",
    fill: "#21272F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.24984 5.84277C6.71007 5.84277 7.08317 6.21587 7.08317 6.67611V13.3428C7.08317 13.803 6.71007 14.1761 6.24984 14.1761C5.7896 14.1761 5.4165 13.803 5.4165 13.3428V6.67611C5.4165 6.21587 5.7896 5.84277 6.24984 5.84277Z",
    fill: "#21272F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2498 5.84277C11.7101 5.84277 12.0832 6.21587 12.0832 6.67611V13.3428C12.0832 13.803 11.7101 14.1761 11.2498 14.1761C10.7896 14.1761 10.4165 13.803 10.4165 13.3428V6.67611C10.4165 6.21587 10.7896 5.84277 11.2498 5.84277Z",
    fill: "#21272F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7498 5.84277C14.2101 5.84277 14.5832 6.21587 14.5832 6.67611V13.3428C14.5832 13.803 14.2101 14.1761 13.7498 14.1761C13.2896 14.1761 12.9165 13.803 12.9165 13.3428V6.67611C12.9165 6.21587 13.2896 5.84277 13.7498 5.84277Z",
    fill: "#21272F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBarcode);
export default __webpack_public_path__ + "static/media/menuBarcode.9cc050a3f9d515c6967e9dbf1de652b9.svg";
export { ForwardRef as ReactComponent };